import { Steps, type StepsProps } from 'antd'
import { useMemo } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import './steps.less'

export const AntdSteps = ({ size = 'small', className, items, ...props }: StepsProps) => {
  // Change cursor to pointer for items with onClick
  const itemsWithOnClickEffects = useMemo(
    () =>
      items?.map((item) => ({
        ...item,
        className: cn(
          item.className,
          item.onClick && 'cursor-pointer',
          item.disabled && 'opacity-40 pointer-events-none',
        ),
      })),
    [items],
  )

  return (
    <div className='w-full'>
      <Steps
        size={size}
        className={cn('w-full py-8', className)}
        items={itemsWithOnClickEffects}
        {...props}
      />
    </div>
  )
}
